/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class SiteAttachmentService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'SiteAttachmentService\' loaded');
    }
}

export { SiteAttachmentService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/SiteAttachmentService.js